import { Box, Text } from '@zillow/constellation-10';

import { AdminModal } from '../AdminModal';

import { useBannerVisibility } from '../../hooks/useBannerVisibility';

import { adminBannerStyles } from '../AdminNav/styles';

import type { Brand, User } from '../../types';

type MockUserNavProps = {
  brand: Brand | string;
  userModel: User | null;
};

export default function MockUserNav(props: MockUserNavProps): JSX.Element | null {
  const { isVisible, handleModalConfirm } = useBannerVisibility();

  const { userModel, brand } = props;
  const { email, userToken, isMocked } = userModel ?? {};

  const content = ' | brand: ' + brand + ' | token: ' + userToken + ' | email: ' + email;

  if (!isMocked || !isVisible) {
    return null;
  }

  return (
    <Box
      data-testid="MockUserNav"
      css={{
        borderBottom: '2px solid {colors.border.accent.gray.strong}',
        backgroundColor: 'bg.accent.yellow.soft',
        ...adminBannerStyles,
      }}
    >
      <Text textStyle="body-sm-bold">Mocked User</Text>
      <Text textStyle="body-sm">{content}</Text>
      <AdminModal isImpersonator={false} onConfirm={handleModalConfirm} />
    </Box>
  );
}
